import { Head, useForm } from "@inertiajs/react";

import Layout from "/AdminLayout";
import { useToast } from "/utils/toast-context.jsx";
import CollectionForm from "/components/Admin/CollectionForm";

const NewCollection = ({
}) => {
  const { data, setData, transform, post, errors } = useForm({
    project_links: [],
  });
  const { successToast, errorToast } = useToast();

  const handleSubmit = (state, preview = false) => {
    transform((data) => ({
      ...data,
      state: state,
      preview: preview,
    }));
    post(
      "/admin/collections",
      {
        preserveScroll: true,
        onSuccess: () => successToast("Сохранено"),
      }
    );
  };

  return (
    <>
      <Head>
        <title>Новая коллекция</title>
      </Head>

      <CollectionForm
        data={data}
        setData={setData}
        onSubmit={handleSubmit}
        errors={errors}
      />
    </>
  );
}

NewCollection.layout = (page) => <Layout children={page} />;

export default NewCollection;
